"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class EvaluatorCertification {
  static thaw(evaluatorCertificationObj) {
    if (evaluatorCertificationObj == null) return null;
    const evaluatorCertification = new EvaluatorCertification();
    if (evaluatorCertificationObj.id != null) evaluatorCertification.setId(evaluatorCertificationObj.id);
    if (evaluatorCertificationObj.evaluatorId != null) evaluatorCertification.setEvaluatorId(evaluatorCertificationObj.evaluatorId);
    if (evaluatorCertificationObj.segmentId != null) evaluatorCertification.setSegmentId(evaluatorCertificationObj.segmentId);
    if (evaluatorCertificationObj.evaluator != null) evaluatorCertification.setEvaluator(_.Evaluator.thaw(evaluatorCertificationObj.evaluator));
    if (evaluatorCertificationObj.segment != null) evaluatorCertification.setSegment(_.ErgoAlgoSegment.thaw(evaluatorCertificationObj.segment));
    if (evaluatorCertificationObj.evaluatorCertificationSubscriptions != null) evaluatorCertification.setEvaluatorCertificationSubscriptions(_.EvaluatorCertificationSubscription.thawList(evaluatorCertificationObj.evaluatorCertificationSubscriptions));
    if (evaluatorCertificationObj.evaluatorCertificationCertificates != null) evaluatorCertification.setEvaluatorCertificationCertificates(_.EvaluatorCertificationCertificate.thawList(evaluatorCertificationObj.evaluatorCertificationCertificates));
    if (evaluatorCertificationObj.evaluatorCertificationTrainingPayments != null) evaluatorCertification.setEvaluatorCertificationTrainingPayments(_.EvaluatorCertificationTrainingPayment.thawList(evaluatorCertificationObj.evaluatorCertificationTrainingPayments));
    if (evaluatorCertificationObj.isComplete != null) evaluatorCertification.setIsComplete(evaluatorCertificationObj.isComplete);
    if (evaluatorCertificationObj.hasPurchasedTraining != null) evaluatorCertification.setHasPurchasedTraining(evaluatorCertificationObj.hasPurchasedTraining);
    if (evaluatorCertificationObj.hasCompletedTraining != null) evaluatorCertification.setHasCompletedTraining(evaluatorCertificationObj.hasCompletedTraining);
    return evaluatorCertification;
  }

  static thawList(evaluatorCertificationObjList) {
    if (evaluatorCertificationObjList == null) return [];
    var evaluatorCertifications = [];

    for (var i = 0; i < evaluatorCertificationObjList.length; i++) {
      evaluatorCertifications.push(EvaluatorCertification.thaw(evaluatorCertificationObjList[i]));
    }

    return evaluatorCertifications;
  }

  static freeze(evaluatorCertification) {
    if (evaluatorCertification == null) return null;
    var evaluatorCertificationObj = {};
    if (evaluatorCertification.getId() != null) evaluatorCertificationObj.id = evaluatorCertification.getId();
    if (evaluatorCertification.getEvaluatorId() != null) evaluatorCertificationObj.evaluatorId = evaluatorCertification.getEvaluatorId();
    if (evaluatorCertification.getSegmentId() != null) evaluatorCertificationObj.segmentId = evaluatorCertification.getSegmentId();
    if (evaluatorCertification.getEvaluator() != null) evaluatorCertificationObj.evaluator = _.Evaluator.freeze(evaluatorCertification.getEvaluator());
    if (evaluatorCertification.getSegment() != null) evaluatorCertificationObj.segment = _.ErgoAlgoSegment.freeze(evaluatorCertification.getSegment());
    if (evaluatorCertification.getEvaluatorCertificationSubscriptions() != null) evaluatorCertificationObj.evaluatorCertificationSubscriptions = _.EvaluatorCertificationSubscription.freezeList(evaluatorCertification.getEvaluatorCertificationSubscriptions());
    if (evaluatorCertification.getEvaluatorCertificationCertificates() != null) evaluatorCertificationObj.evaluatorCertificationCertificates = _.EvaluatorCertificationCertificate.freezeList(evaluatorCertification.getEvaluatorCertificationCertificates());
    if (evaluatorCertification.getEvaluatorCertificationTrainingPayments() != null) evaluatorCertificationObj.evaluatorCertificationTrainingPayments = _.EvaluatorCertificationTrainingPayment.freezeList(evaluatorCertification.getEvaluatorCertificationTrainingPayments());
    if (evaluatorCertification.getIsComplete() != null) evaluatorCertificationObj.isComplete = evaluatorCertification.getIsComplete();
    if (evaluatorCertification.getHasPurchasedTraining() != null) evaluatorCertificationObj.hasPurchasedTraining = evaluatorCertification.getHasPurchasedTraining();
    if (evaluatorCertification.getHasCompletedTraining() != null) evaluatorCertificationObj.hasCompletedTraining = evaluatorCertification.getHasCompletedTraining();
    return evaluatorCertificationObj;
  }

  static freezeList(evaluatorCertifications) {
    if (evaluatorCertifications == null) return [];
    var evaluatorCertificationObjList = [];

    for (var i = 0; i < evaluatorCertifications.length; i++) {
      evaluatorCertificationObjList.push(EvaluatorCertification.freeze(evaluatorCertifications[i]));
    }

    return evaluatorCertificationObjList;
  }

  constructor() {
    this.setId(null);
    this.setEvaluatorId(null);
    this.setSegmentId(null);
    this.setEvaluator(null);
    this.setSegment(null);
    this.setEvaluatorCertificationSubscriptions(null);
    this.setEvaluatorCertificationCertificates(null);
    this.setEvaluatorCertificationTrainingPayments(null);
    this.setIsComplete(null);
    this.setHasPurchasedTraining(null);
    this.setHasCompletedTraining(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setEvaluatorId(evaluatorId) {
    this.evaluatorId = evaluatorId;
  }

  setSegmentId(segmentId) {
    this.segmentId = segmentId;
  }

  setEvaluator(evaluator) {
    this.evaluator = evaluator;
  }

  setSegment(segment) {
    this.segment = segment;
  }

  setEvaluatorCertificationSubscriptions(evaluatorCertificationSubscriptions) {
    this.evaluatorCertificationSubscriptions = evaluatorCertificationSubscriptions;
  }

  setEvaluatorCertificationCertificates(evaluatorCertificationCertificates) {
    this.evaluatorCertificationCertificates = evaluatorCertificationCertificates;
  }

  setEvaluatorCertificationTrainingPayments(evaluatorCertificationTrainingPayments) {
    this.evaluatorCertificationTrainingPayments = evaluatorCertificationTrainingPayments;
  }

  setIsComplete(isComplete) {
    this.isComplete = isComplete;
  }

  setHasPurchasedTraining(hasPurchasedTraining) {
    this.hasPurchasedTraining = hasPurchasedTraining;
  }

  setHasCompletedTraining(hasCompletedTraining) {
    this.hasCompletedTraining = hasCompletedTraining;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getEvaluatorId() {
    return this.evaluatorId;
  }

  getSegmentId() {
    return this.segmentId;
  }

  getEvaluator() {
    return this.evaluator;
  }

  getSegment() {
    return this.segment;
  }

  getEvaluatorCertificationSubscriptions() {
    return this.evaluatorCertificationSubscriptions;
  }

  getEvaluatorCertificationCertificates() {
    return this.evaluatorCertificationCertificates;
  }

  getEvaluatorCertificationTrainingPayments() {
    return this.evaluatorCertificationTrainingPayments;
  }

  getIsComplete() {
    return this.isComplete;
  }

  getHasPurchasedTraining() {
    return this.hasPurchasedTraining;
  }

  getHasCompletedTraining() {
    return this.hasCompletedTraining;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluatorCertification;